export default __webpack_public_path__ + "static/media/affected_questions_alert.ebce7ea8.svg";